const state = {
  showBubbles: false,
  showTips: false,
};

const mutations = {
  TOGGLE_BUBBLE(state, value) {
    state.showBubbles = value;
  },

  TOGGLE_TIPS(state, value) {
    state.showTips = value;
  },
};

const actions = {
  
  SHOW_BUBBLES({ commit }) {
    commit('TOGGLE_BUBBLE', true);
  },

  HIDE_BUBBLES({ commit }) {
    commit('TOGGLE_BUBBLE', false);
  },

  SHOW_TIPS({ commit }) {
    commit('TOGGLE_TIPS', true);
  },

  HIDE_TIPS({ commit }) {
    commit('TOGGLE_TIPS', false);
  }
};

const getters = {
  showBubbles: state => state.showBubbles,
  showTips: state => state.showTips,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
